<script lang="ts">
    import type * as t from "~/types";
    import { getAppContext } from "~/quiz-store";
    import type { SequenceNode } from "~/sequence";
    import { onMount } from "svelte";
    import Options from "./Options.svelte";
    import { createContext } from "./context";
    import { cn } from "~/utils";
    import { EventEmitter } from "~/event-emitter";
    import StepHeader from "~/components/StepHeader.svelte";
    import PaddingX from "~/components/PaddingX.svelte";

    export let stepNode: SequenceNode<t.Step>;
    export let visible: boolean;

    const step = (stepNode as SequenceNode<t.MultipleChoiceStep>).value;
    const { actions, hooks, ...appCtx } = getAppContext();

    const ctx = createContext(step);

    let container: HTMLElement;
    let optionsVisible: boolean = false;
    let titleShadowVisible = false;
    let optionsContainerWidth: number;
    let optionsContainerHeight: number;
    let optionsContainerOrientation: "portrait" | "landscape" = "portrait";

    $: optionsContainerOrientation =
        optionsContainerHeight > optionsContainerWidth
            ? "portrait"
            : "landscape";

    function handleContentScroll(e: t.AppEvent.OnContentScroll) {
        titleShadowVisible = e.y > 0;
    }

    function setupContainer() {
        setTimeout(
            () => {
                appCtx.events.emit<t.AppEvent.OnContentReady>(
                    EventEmitter.EVENT.ON_CONTENT_READY,
                    { target: container },
                );
                // We need to delay the calculation of scrollHeight and clientHeight
                // to account for the reveal delay of the options
            },
            350 * (step.options.length + 1),
        );
    }
    onMount(() => {
        $ctx.onSelectOption(actions.handleSelectOption);

        hooks.onBeforeProceed(stepNode, () => {
            if ($ctx.selectedOption == null) {
                console.error(
                    "[shpln-quiz] Selected option is undefined before proceed.",
                );
                return;
            }
            actions.incrementScore($ctx.selectedOption);
        });

        appCtx.events.on<t.AppEvent.OnContentScroll>(
            EventEmitter.EVENT.ON_CONTENT_SCROLL,
            handleContentScroll,
        );

        return () => {
            appCtx.events.off(
                EventEmitter.EVENT.ON_CONTENT_SCROLL,
                handleContentScroll,
            );
        };
    });

    $: visible && setupContainer();
    $: visible &&
        setTimeout(() => {
            optionsVisible = visible;
        }, 0);
</script>

{#if visible}
    <div
        class="flex size-full flex-col"
        bind:this={container}
        bind:clientWidth={optionsContainerWidth}
        bind:clientHeight={optionsContainerHeight}
    >
        {#if step.title != null}
            <div
                class={cn(
                    "sticky top-0 z-10 w-full rounded-b-2xl bg-white pb-4  transition-[box-shadow]",
                    titleShadowVisible && "shadow-lg",
                )}
            >
                <StepHeader title={step.title} subtitle={step.subtitle} />
            </div>
        {/if}
        <PaddingX class="flex flex-1 flex-col items-center justify-center">
            <Options
                visible={optionsVisible}
                {step}
                orientation={optionsContainerOrientation}
            />
        </PaddingX>
    </div>
{/if}
